import { render, staticRenderFns } from "./PortalFeatures.vue?vue&type=template&id=f53426ee&scoped=true"
import script from "./PortalFeatures.vue?vue&type=script&lang=js"
export * from "./PortalFeatures.vue?vue&type=script&lang=js"
import style0 from "./PortalFeatures.vue?vue&type=style&index=0&id=f53426ee&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f53426ee",
  null
  
)

export default component.exports